export const environment= {
    production: false,
    HTTP:'https://alcp-uat.qubeposcloud-uatapi.com/api/central',
    appVersion: 'v9.0.2.9',
    baseHref: '/alcp',
    qcURL: 'https://qubeconnect-uat.qubeposcloud-uat.com/qubeconnect/',
    qubeconnectAPI: 'https://qubeconnect-uat.qubeposcloud-uat.com/qubeconnect/gateway.php?path=',
    isQubeconnect: false,
    gatewaySignatureQubeConnect: "4ba86b860c91acedd6c319253277c115718b77996781d0772a882313eb2cd8fc",
    DEMO: 'UAT'
  }